function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnauthorized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.57,259.19s-16.11-3.05-25.86,15.38c-8.22,15.51-42.18,97.13-52.7,122.51h42c8.87-40.35,26-113.81,33.44-116.55,10.29-3.8,25.94.27,25.94.27Z",
    style: {
      fill: "#A19EE7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.18,296.87s6.9,60.2,58.06,85.92,101.27.7,147.28-5.33c24.09-3.15,46.44,8.69,70.06,11.17,75.54,7.93,134.82-81.08,124.18-146.56-9.2-56.69-45.43-96.7-111.43-125.24S227.93,65.57,151.26,92.41,45.71,218.93,51.18,296.87Z",
    style: {
      fill: "#A19EE7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.18,296.87s6.9,60.2,58.06,85.92,101.27.7,147.28-5.33c24.09-3.15,46.44,8.69,70.06,11.17,75.54,7.93,134.82-81.08,124.18-146.56-9.2-56.69-45.43-96.7-111.43-125.24S227.93,65.57,151.26,92.41,45.71,218.93,51.18,296.87Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.31,383.86H449.6V150.92H304.31Zm75.81-56h63.76V322.2H380.12v-52h63.76v-5.64H380.12V213.66h63.76V208H380.12V156.56H444.3V378.21H380.12Zm-70.5-171.29h65.19V208H309.62Zm0,57.1h65.19v50.91H309.62Zm0,56.55h65.19v52H309.62Zm0,57.64h65.19v50.36H309.62Z",
    style: {
      fill: "#b5b5b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.11,145.58a72.93,72.93,0,0,0-145.26,0l-.34,3.81H449.45ZM311.26,142.4a65.62,65.62,0,0,1,16.53-34.85l41,34.85Zm61-6.17L332.8,102.64A65.6,65.6,0,0,1,372.29,86.4Zm7-49.91a65.71,65.71,0,0,1,37.88,13.82l-37.88,35.58Zm3.09,56.08,40.08-37.65A65.52,65.52,0,0,1,441.7,142.4Z",
    style: {
      fill: "#b5b5b5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134,302.73a16.92,16.92,0,0,0-8.29,5.07,36.21,36.21,0,0,0-5,6.8c-.9,1.56-1.72,3.17-2.48,4.8-.49,1.06-.86,2.39-1.33,3.61-.67,1.08-1.33,2.19-1.9,3.23,2-7.21,8.46-20.48,8.57-24.25.13-4.1-3.81,2-6,10.35a116.29,116.29,0,0,0-2.82,14.39c-.23.43-.43.84-.61,1.22-.4.84-1.09,2.27-2,4.13,2-6.12,2.73-13.39,1.52-14.29-1.75-1.3-2.38,1.89-2.37,7.78A50.68,50.68,0,0,1,109.22,338c-1.1,2.18-2.33,4.58-3.65,7.11,1.38-4.41,2.18-10.76,2.94-15.52,1.1-6.92.63-9.08-1.61-5.75s-1.85,8.15-1.32,14.05a24.58,24.58,0,0,1-2,11c-1.69,3.21-3.48,6.52-5.29,9.78a33.36,33.36,0,0,0,2.88-10.57c.78-8-.25-15.35-2.1-13.27s-.76,7.65-1,14.43a77,77,0,0,1-1.39,12.22l-.56,1A33.45,33.45,0,0,0,96.7,352c.37-1.34.24-2.19-.21-2.6-.06-1.51.06-3.78-.58-4.93-1.62-2.89-3.39,1-3.41,2.54a25.88,25.88,0,0,0,.24,3.51,9.3,9.3,0,0,0-1.62,2c-.24.41-.5.87-.77,1.37,0-.48.06-1,.08-1.46a7.17,7.17,0,0,0-.8-3.77,23.54,23.54,0,0,0,2.09-6.15,3.36,3.36,0,0,0-.18-2.13,1.74,1.74,0,0,0-2.59-.7c-3.08,1.63-3.9,5.55-4.25,8.69a52.21,52.21,0,0,1-1.6,8c-.63,2.37-1.18,4.51-1.54,6-.27-1.65-.58-3.25-1-4.73-.35-1.29-.68-2.54-1-3.74a25.07,25.07,0,0,1,2.48-12.67c3.64-7.48,6.27-11,3.75-11.13s-6.18,3.77-6.7,9.93a68.92,68.92,0,0,0-.24,11.25c-.8-2.87-1.59-5.57-2.41-8.32a18.19,18.19,0,0,1,.45-9.15c1.72-5.08,6.85-14.1,4.15-13.39s-5.94,5.94-6.3,11.48a30.14,30.14,0,0,0,.95,8.6c-.59-1.93-1.21-3.92-1.88-6-.28-.9-.58-1.85-.87-2.84,0-.16,0-.33-.08-.5a14.06,14.06,0,0,1,1.48-8.33c2.58-4.64,7.38-8.62,4.55-9.69s-7.12,6.49-7.36,10.27a18,18,0,0,0,.34,4.28c-.11-.29-.23-.59-.35-.88-.61-2.16-1.2-4.3-1.72-6.2a17.34,17.34,0,0,1,1.64-8.11c2.52-5.78,5.73-12.39,2.46-10.71-2.64,1.36-5.49,9.16-4.93,15.74-.22-.86-.42-1.6-.58-2.2-.43-3.77-1.24-12.65,0-17.94.81-3.53,2.13-6.87,2.54-10.5a2.23,2.23,0,0,0-.06-1.12c-.88-2.19-3.73,2.07-4.2,2.77a16.93,16.93,0,0,0-2.59,9.37,35.89,35.89,0,0,0,1,8.38c.4,1.75.89,3.49,1.46,5.2.36,1.11,1,2.34,1.49,3.54.24,1.25.52,2.52.81,3.66C65.38,312,61,297.88,58.55,295c-2.71-3.08-1.4,4.09,2.66,11.68A116.31,116.31,0,0,0,69,319.16c.13.47.26.91.39,1.31.28.89.75,2.41,1.35,4.39-2.75-5.81-7.14-11.65-8.64-11.49-2.16.24-.44,3,3.58,7.31a51,51,0,0,1,6.93,10.48c.68,2.35,1.42,4.94,2.18,7.69-2-4.17-5.75-9.36-8.44-13.35-3.92-5.81-5.74-7.07-5.11-3.11s4.21,7.22,8.64,11.17A24.74,24.74,0,0,1,75.9,343c.95,3.49,1.9,7.14,2.8,10.76a33.39,33.39,0,0,0-5.1-9.7C68.7,337.66,62.93,333,63,335.78s4.66,6.11,9.13,11.2a75.11,75.11,0,0,1,7.32,9.89c.09.36.18.73.26,1.09-2-3.67-5.19-6.66-8.29-9.42-1.09-1-2.74-3.1-4.15-3.55-3.14-1-1.79,3.05-.75,4.18,3.36,3.68,8.1,5.95,11.21,9.82a34,34,0,0,1,3.14,4.64c.22,1.27.38,2.46.51,3.57A48.67,48.67,0,0,0,77.63,364c-3.8-2.56-6-6.07-8.93-9.45-.88-1-2.37-2.25-3.78-2.31-2-.09-2.59,2-2,3.65,2.31,6.8,11,7.1,16.09,10.63a14.82,14.82,0,0,1,2.57,2.08,43.19,43.19,0,0,1,.17,6.32H70.06v4.87h3.47l2.82,17.34H99.71l2.82-17.34H106v-4.87H88.43c.8-1,1.66-2,2.52-3.14l3.7.11s12.84.56,17.55-2,.51-5-4-3.69-13.37,5.31-15.33,5.25l-1.66-.05c.92-1.19,1.84-2.43,2.71-3.69a86,86,0,0,0,10.41-3.32c3.69-1.46,8-2.64,11.14-5.11a3.4,3.4,0,0,0,1.32-1.68,1.74,1.74,0,0,0-1.41-2.27c-3.37-.91-6.65,1.39-9,3.45a53,53,0,0,1-6.63,4.76c-2.08,1.29-3.94,2.49-5.21,3.31.93-1.38,1.79-2.77,2.52-4.12.63-1.18,1.24-2.31,1.82-3.42a25.08,25.08,0,0,1,10.46-7.57c7.76-3,12.07-3.74,10.34-5.57s-7.1-1.47-11.68,2.68a68.1,68.1,0,0,0-7.86,8.06c1.37-2.64,2.65-5.16,3.92-7.73a18.23,18.23,0,0,1,6.58-6.38c4.72-2.53,14.62-5.63,12.16-6.95s-8.39.28-12.43,4.09a30,30,0,0,0-5.18,6.94c.89-1.82,1.79-3.7,2.74-5.69.41-.86.85-1.75,1.3-2.67.1-.14.2-.28.29-.43a14,14,0,0,1,6.77-5.07c5-1.63,11.28-1.27,9.93-4s-9.63-.11-12.39,2.48a18.71,18.71,0,0,0-2.67,3.36c.12-.28.24-.58.35-.88,1-2,2-4,3-5.7a17.32,17.32,0,0,1,6.73-4.81c5.79-2.5,12.65-5.15,9.11-6.15-2.86-.81-10.27,2.94-14.34,8.14l1.07-2c2.26-3.06,7.73-10.1,12.23-13.13,3-2,6.25-3.57,9-5.94a2.37,2.37,0,0,0,.72-.86C139.85,301.36,134.86,302.53,134,302.73ZM81.72,363.35c.75-1.15,2.08-3.27,3.55-6A37.87,37.87,0,0,0,86.82,361c-1.36,2.79-2.6,5.22-3.32,5.84l-1.24,1.1C82.12,366.41,81.94,364.87,81.72,363.35Zm8.5,8.09c-1.06,1.37-2,2.51-2.94,3.47H82.72c-.07-1.86-.2-4.14-.42-6.57l2.78-2.45s1.22-1,2.86-2.61a23.5,23.5,0,0,1,1.83,4.88A14.24,14.24,0,0,1,90.22,371.44ZM94,361.82a34.53,34.53,0,0,1-.87,5.54c-.71,1.08-1.4,2.06-2.06,3-.06-1.68-.51-4.71-.56-4.92a20.64,20.64,0,0,1-.51-4.14A54.37,54.37,0,0,0,93.78,357,22.5,22.5,0,0,1,94,361.82Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368,363.31l16.19,26.07A5,5,0,0,1,380,397H346.9a5,5,0,0,0,4.25-7.6l-15.66-25.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.02 363.31 335.49 363.89 341.51 373.7 374.47 373.7 368.02 363.31",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.55,
    y: 252.34,
    width: 138.27,
    height: 116.78,
    rx: 2.91,
    transform: "translate(695.37 621.46) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.32,
    y: 252.34,
    width: 138.27,
    height: 116.78,
    rx: 2.91,
    transform: "translate(684.91 621.46) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,252.34H407a4.65,4.65,0,0,1,4.64,4.65V348.2H273.32V257A4.65,4.65,0,0,1,278,252.34Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.13,
    y: 256.99,
    width: 126.65,
    height: 84.82,
    transform: "translate(684.91 598.8) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.74,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.1,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.47,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.83,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.19,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.56,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.92,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.28,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.65,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.01,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.37,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.74,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.1,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.46,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.83,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.19,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.55,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.92,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.28,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.64,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.01,
    y: 391.16,
    width: 4.02,
    height: 1.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.66,
    y: 392.7,
    width: 116.29,
    height: 4.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.59,
    y: 392.7,
    width: 28.37,
    height: 4.34,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.25,309.48l17.8-42.09h10.68v42.09h4.62v8.9h-4.62v11.3h-9.61v-11.3H294.25Zm18.87,0v-23.4l-9.88,23.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,282.34c0-10,5.25-15.66,14.86-15.66s14.86,5.69,14.86,15.66v32.39c0,10-5.25,15.66-14.86,15.66S331,324.69,331,314.73Zm9.79,33c0,4.45,2,6.14,5.07,6.14s5.08-1.69,5.08-6.14V281.72c0-4.45-2-6.14-5.08-6.14s-5.07,1.69-5.07,6.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.09,275.22c7.57,0,9.26-3.65,10.77-7.83h6.58v62.29h-9.78V282.16h-7.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.13,419.63c0,1.47.58,2.36,1.91,2.36s1.88-.89,1.88-2.36V407.17h1.71v12.37c0,2.47-1.15,4.13-3.66,4.13s-3.64-1.66-3.64-4.13V407.17h1.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,423.48H300.4V407.17h2.3L306.48,419V407.17h1.61v16.31H306.2L302,410.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.79,420.19l-.63,3.29h-1.68l3.13-16.31h2.63l3.12,16.31h-1.82l-.62-3.29Zm.23-1.56h3.64l-1.84-9.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.51,419.63c0,1.47.58,2.36,1.91,2.36s1.88-.89,1.88-2.36V407.17H327v12.37c0,2.47-1.15,4.13-3.66,4.13s-3.64-1.66-3.64-4.13V407.17h1.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.15,423.48V408.82h-3v-1.65H336v1.65h-3v14.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,416.14v7.34h-1.81V407.17H339v7.34h4v-7.34h1.82v16.31H343v-7.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.55,411.11c0-2.5,1.24-4.11,3.73-4.11s3.75,1.61,3.75,4.11v8.43c0,2.47-1.23,4.1-3.75,4.1s-3.73-1.63-3.73-4.1Zm1.8,8.52c0,1.5.63,2.36,1.93,2.36s1.94-.86,1.94-2.36V411c0-1.47-.61-2.35-1.94-2.35s-1.93.88-1.93,2.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.39,407.17c2.57,0,3.64,1.3,3.64,3.73v1.32c0,1.8-.63,2.92-2,3.36,1.49.44,2.05,1.65,2.05,3.4v2.54a4,4,0,0,0,.33,2h-1.84a4.27,4.27,0,0,1-.31-2v-2.57c0-1.84-.86-2.42-2.37-2.42h-1.29v7h-1.81V407.17Zm-.46,7.69c1.44,0,2.3-.47,2.3-2.24v-1.56c0-1.47-.53-2.24-1.88-2.24h-1.78v6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.75,407.17v16.31h-1.81V407.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.77,423.48h-7.41v-1.63l5.59-13h-5.33v-1.65h7.2v1.63l-5.62,13h5.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.25,414.39V416h-4v5.81h4.89v1.65h-6.71V407.17h6.71v1.65h-4.89v5.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.66,407.17c2.54,0,3.7,1.54,3.7,4.05v8.23c0,2.49-1.16,4-3.7,4h-3.82V407.17Zm0,14.66c1.3,0,1.93-.82,1.93-2.31v-8.39c0-1.49-.63-2.31-2-2.31h-2v13Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.37,203.86a30.66,30.66,0,0,1,2.8,13.32c0,8-3.85,15.76-2.8,18.92s1.41,14.26-.76,16.43c-1.24,1.24-6.5-.36-6.5-.36s-1.41,4.2-2.81,4.2-5.25-.7-6.65,1.75.7,5.26-.7,6.66a19,19,0,0,1-3.16,2.45s-3.71,3.39-6.17,3.39-14.55-8.53-14.55-8.53S202.84,268,199,270.82s-6,12.42-6,12.42-20.78-14.75-17.27-28.41,44.7-33.1,58-40.81S253.37,203.86,253.37,203.86Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.22,232.24s1.18-5.43-3.72-5.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.29665px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.56,221.21c-.49-.93,4.84-4,8.63-.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.29665px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.62,232.08c-.61,1.27-1.67,2-2.37,1.7s-.76-1.64-.15-2.91,1.68-2,2.37-1.71S250.24,230.8,249.62,232.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.61,246.73a2.78,2.78,0,1,1-2.78-2.78A2.78,2.78,0,0,1,213.61,246.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.83,
    y1: 249.51,
    x2: 210.83,
    y2: 259.32,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.67,256.05s-4.25,12.1-3.6,13.08,7.69.49,8.18,0S210.67,256.05,210.67,256.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.42,301.44s8.73,5.64,6.48,5.92a11.72,11.72,0,0,1-7.32-1.69,12.67,12.67,0,0,0-6.77-1.69h-5.63s2.25-4,5.07-4.51S229.42,301.44,229.42,301.44Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.86,296.93s11.83,5.64,11.55,7.05-.85,1.69-3.95,1.41-9.29-3.95-9.29-3.95l-7-1.13S224.35,294.12,228.86,296.93Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.27,300.31s11.27-5.91,13.81-7.32,7.61-.85,11.27-.85,15.5.28,16.06,2.54-3.38,2.82-7.33,2.82-7.32-.57-10.42,2.81a27.69,27.69,0,0,0-4.79,7.89,55,55,0,0,0,9,1.13c3.66,0,9.29,1.41,8.73,3.1s-2,3.38-6.48,2.82-10.71.28-15.5.56-12.11-1.13-12.11-1.13Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.41,280.8s3,0,.91,6.66S201,306.81,201,306.81l-9.68-32.06Z",
    style: {
      fill: "#545454",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.07,397.08a28.77,28.77,0,0,0,1.82-2.94c6.14-11.56,8.31-47.68,7.23-71.53s-1.86-37.79-6.55-46.46c0,0-11.1-12.51-22.3-17.93s-31.85,10.2-42,25.74S100,377.89,93.47,392.7a11.78,11.78,0,0,0-1,4.38Z",
    style: {
      fill: "#A19EE7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.26,334.29a40.84,40.84,0,0,0,5.67-.15c.87,0,10.39-1.4,7.83-4-.79-.79-3.12-.7-4.14-.83A67.44,67.44,0,0,0,281,329l6.54-2.73a31.78,31.78,0,0,1,4.2-.26c.8,0,1.7,0,2.63,0,1.59,0,5.53-.56,6.32-2.14,1.27-2.54-9.59-3.69-11.16-3.69s-9.66,1-10.09,1l-1.61.32h-.29s7.58-2.17,10.83-2.17,7.59,1.09,8.67-2.17-7.22-2.16-14.45-1.8-12.28,4.69-16.61,8.31-12.65,19.14-21.68,27.09S216.48,366,216.48,366s-10.86-61.46-15.55-79.16-17-22.29-17-22.29l-16.75,54.71c2.12,11.44,15,71,15.67,72.39a25.34,25.34,0,0,0,3.18,5.46h42a59.8,59.8,0,0,0,5.35-5.1c5.78-6.15,25.29-40.1,25.29-40.1s2.17-.36,7.23-3.26c3.28-1.87,8.41-6.82,12.39-5.93a40.48,40.48,0,0,0,9.95.61c2.72-.08,5.94-.2,8-2.26,1.69-1.69-1.85-1.38-2.8-1.46-3-.25-5.75-1.4-8.63-2.15-.91-.24-4.31-1.53-5.19-1.09a27.46,27.46,0,0,0,2.53-1.44C283.32,334.17,285.09,334.29,287.26,334.29Z",
    style: {
      fill: "#A19EE7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.26,334.29a40.84,40.84,0,0,0,5.67-.15c.87,0,10.39-1.4,7.83-4-.79-.79-3.12-.7-4.14-.83A67.44,67.44,0,0,0,281,329l6.54-2.73a31.78,31.78,0,0,1,4.2-.26c.8,0,1.7,0,2.63,0,1.59,0,5.53-.56,6.32-2.14,1.27-2.54-9.59-3.69-11.16-3.69s-9.66,1-10.09,1l-1.61.32h-.29s7.58-2.17,10.83-2.17,7.59,1.09,8.67-2.17-7.22-2.16-14.45-1.8-12.28,4.69-16.61,8.31-12.65,19.14-21.68,27.09S216.48,366,216.48,366s-5.06-27.68-9.76-50.85a69.12,69.12,0,0,0-36.15,20.53c4.55,21.66,11.8,54.94,12.32,56a25.34,25.34,0,0,0,3.18,5.46h42a59.8,59.8,0,0,0,5.35-5.1c5.78-6.15,25.29-40.1,25.29-40.1s2.17-.36,7.23-3.26c3.28-1.87,8.41-6.82,12.39-5.93a40.48,40.48,0,0,0,9.95.61c2.72-.08,5.94-.2,8-2.26,1.69-1.69-1.85-1.38-2.8-1.46-3-.25-5.75-1.4-8.63-2.15-.91-.24-4.31-1.53-5.19-1.09a27.46,27.46,0,0,0,2.53-1.44C283.32,334.17,285.09,334.29,287.26,334.29Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.26,334.29a40.84,40.84,0,0,0,5.67-.15c.87,0,10.39-1.4,7.83-4-.79-.79-3.12-.7-4.14-.83A67.44,67.44,0,0,0,281,329l6.54-2.73a31.78,31.78,0,0,1,4.2-.26c.8,0,1.7,0,2.63,0,1.59,0,5.53-.56,6.32-2.14,1.27-2.54-9.59-3.69-11.16-3.69s-9.66,1-10.09,1l-1.61.32h-.29s7.58-2.17,10.83-2.17,7.59,1.09,8.67-2.17-7.22-2.16-14.45-1.8-12.28,4.69-16.61,8.31-12.65,19.14-21.68,27.09S216.48,366,216.48,366s-4.16-22.76-8.44-44.28a60.7,60.7,0,0,0-36.17,20.14c4.51,21.28,10.55,48.85,11,49.79a25.34,25.34,0,0,0,3.18,5.46h42a59.8,59.8,0,0,0,5.35-5.1c5.78-6.15,25.29-40.1,25.29-40.1s2.17-.36,7.23-3.26c3.28-1.87,8.41-6.82,12.39-5.93a40.48,40.48,0,0,0,9.95.61c2.72-.08,5.94-.2,8-2.26,1.69-1.69-1.85-1.38-2.8-1.46-3-.25-5.75-1.4-8.63-2.15-.91-.24-4.31-1.53-5.19-1.09a27.46,27.46,0,0,0,2.53-1.44C283.32,334.17,285.09,334.29,287.26,334.29Z",
    style: {
      fill: "#b2b2b2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.48,
    y1: 365.97,
    x2: 220.28,
    y2: 384.57,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.57,259.19s-16.11-3.05-25.86,15.38c-8.22,15.51-42.18,97.13-52.7,122.51h42c8.87-40.35,26-113.81,33.44-116.55,10.29-3.8,25.94.27,25.94.27Z",
    style: {
      fill: "#A19EE7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144,397.08c8.87-40.35,26-113.81,33.44-116.55,10.29-3.8,25.94.27,25.94.27l-22.84-21.61s-16.11-3.05-25.86,15.38c-8.22,15.51-42.18,97.13-52.7,122.51Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.57,259.19s-16.11-3.05-25.86,15.38c-8.22,15.51-42.18,97.13-52.7,122.51h42c8.87-40.35,26-113.81,33.44-116.55,10.29-3.8,25.94.27,25.94.27Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.36,
    y: 392.7,
    width: 33.6,
    height: 4.34,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.94,203.76s-4.33,15.17-25.28,25.29S202,245.3,196.25,250s-9.75,11.92-23.48,3.61-11.56-37.57-6.86-52.38,16.61-31.43,43.35-30.71,49.85,17.7,50.94,24.57S256.94,203.76,256.94,203.76Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.81,196.91a5.59,5.59,0,1,1-5.57-5.08A5.34,5.34,0,0,1,188.81,196.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.43,211.65s3.35-10.23-4.39-13-8.19,3.65-29,12.74-35,12.47-38.89,23.4,4,16.7,4,16.7-15.69,7.38-18.68,18.79,6.31,23.39,28,28.39,37.31-4.65,42.2-12.82,6.28-19,6.28-19,5.5,5.51,12.22-8.89S183.43,211.65,183.43,211.65Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.39,250.36c3.25-13.73-5.06-49.13-5.06-49.13",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.4,294.56c-14.63,3.21-25-14.23-14.83-25.54a16.4,16.4,0,0,1,14.56-5.12c3,.49,6.12,2.1,7.27,4.94a8.74,8.74,0,0,1-.25,6.26c-2.33,6.15-17.89,14.21-17.89,2.5,0-5.33,7.94-10.53,9.69-6.78s.49,6.3-2.42,6.3",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.31,238.35c-3.87,0-5.81,9.69,1,10.66s17.56-3.17,9.69-13.08c-3.92-5-20.83-7.27-25.68,1.93s1,20.84,17,23.27c10.85,1.64,25.42-1.59,26.17-15,.48-8.72.48-36.83.48-36.83",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.5,230.59s-17,10.18-11.63,20.36,28.6,8.72,28.6,8.72",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.75,255.31s-18.9,2.42-16,20.84",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88.23,
    y: 152.82,
    width: 225.84,
    height: 244.22,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.74,
    y1: 397.12,
    x2: 427.82,
    y2: 397.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.14832px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/unauthorized.4f14cbb56a573bc22a3ef14ee0ad076d.svg";
export { ForwardRef as ReactComponent };